<script>
import {Message} from "element-ui";
import {
  accountList,
  bindRoleForUser, bindUserOffice,
  deleteAccountById,
  enableAccountById,
  getRoleIdByUserId, getUserOfficeRef,
  roleList,
  saveAccount, updateAccount,
} from "@/api/user";
import {officeList} from "@/api/office";
import UserBind from "@/views/account/UserBind.vue";

export default {
  name: 'UserAccount',
  components: {UserBind},
  data() {
    return {
      // 分页参数
      currentPage: 1,
      pageSize: 10,
      total: 0,
      userList: [],
      visible: false,
      user: {},
      submitLoading: false,
      roles: [],
      searchKeyword: '',
      officeId : null,
      roleCode : null,
      rules: {
        account: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}
        ],
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'}
        ],
        gender: [
          {required: true, message: '请选择性别', trigger: 'change'}
        ],
      },
      roleDialogVisible : false,
      selectUserId : null,
      currentRoleId : null,
      officeDialogVisible: false,
      officeList : [],
      bindOffice : {
        officeId : null
      },
    }
  },
  async mounted() {
    await this.getCacheOffice();
    this.fetchUserList();
    this.fetchRoles();
    this.fetchOffices();
  },
  methods: {
    async getCacheOffice(){
      const user = JSON.parse(localStorage.getItem('user'))
      this.officeId = user.sysAccount.officeId
      const [role] = user.sysAccount.sysRole
      this.roleCode = role.code
      console.log('roleCode', this.roleCode)
      return Promise.resolve();
    },

    // 获取企业
    async fetchOffices() {

      const param = {
        current : 1,
        size : 1000,
        "filter": [
          {
            "name": "enabled",
            "value": 1,
            "type": "EQ"
          }
        ],
        sorted: [
          {
            "name": "createdTime",
            "type": "DESC"
          }
        ],
      }

      try {
        const res = await officeList(param);
        if (res && res.code === "0000"){
          if (this.roleCode === 'agent'){
            this.officeList = res.result.records || []
          }else {
            this.officeList = res.result.records;
          }
        }
      } catch (error) {
        console.error('获取企业列表失败：', error);
        this.$message.error('加载企业列表失败，请重试');
      }
    },
    // 为表格行添加交替样式
    tableRowClassName({row, rowIndex}) {
      return rowIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd';
    },

    openEditDrawer() {
      if (this.user.id) {
        this.user = {}
      }
      this.visible = !this.visible;
    },

    async fetchUserList() {
      try {
        const params = {
          current: this.currentPage,
          size: this.pageSize,
        }
        if (this.searchKeyword) {
          params.filter = this.searchKeyword
        }

        // 这里应该调用实际的 API
        const resp = await accountList(params);
        this.userList = resp.result.records || [];
        this.total = resp.result.total;

      } catch (e) {
        console.log(e)
        this.userList = []; // 确保有默认空数组
      }
    },

    async fetchRoles() {
      try {
        const params = {
          current: 1,
          size: 100,
          filter: [],
          sorted: [{
            name: 'createdTime',
            type: 'ASC'
          }]
        }
        const resp = await roleList(params);
        if (this.roleCode === 'agent'){
          this.roles = resp.result.records.filter(role => role.code === 'officeAdmin') || []
        }else if (this.officeId !== 0){
          this.roles = resp.result.records.filter(role => role.code === 'officeAdmin' || role.code === 'officeAccount') || []
        } else {
          this.roles = resp.result.records || [];
        }

      } catch (e) {
        console.log(e)
        this.roles = [];
      }
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchUserList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchUserList()
    },

    async submitUser() {
      if (!this.user.account) {
        Message.error('请输入账号名');
        return;
      }
      if (!this.user.username) {
        Message.error('请输入用户名');
        return;
      }
      if (!this.user.password && !this.user.id) {
        Message.error('请输入密码');
        return;
      }
      if ( !this.user.officeId) {
        // if (this.officeId === 0){
        //   Message.error('请选择企业');
        //   return;
        // }
      }
      if (this.user.clientType !== 'SEM' && !this.user.roleId) {
        Message.error('请选择角色');
        return;
      }

      this.submitLoading = true;
      try {
          // 新增
          if (!this.user.id){
            const param = {
              ...this.user,
              ...(this.officeId !== 0 ? { officeId: this.officeId } : {})
            }
            const res = await saveAccount(param);
            if (res && res.code === "0000") {
              Message.success('新增用户成功');
            }
          }else {
            const param = {
              ...this.user
            }
            const res = await updateAccount(param);
            if (res && res.code === "0000") {
              Message.success('编辑用户成功');
            }
          }
        this.cleanUser();
        this.fetchUserList();

      } catch (e) {
        Message.error('操作失败');
      } finally {
        this.submitLoading = false;
      }

      this.cleanUser();
      this.fetchUserList();
      this.$refs.editDrawer.closeDrawer()
    },

    async enableUser(id) {
      try {
        const res = await enableAccountById(id);
        if (res && res.code === "0000") {
          Message.success(`操作成功`);
          this.fetchUserList();
        }
      } catch (e) {
        Message.error('操作失败');
      }
    },

    async deleteUser(id) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        try {
          deleteAccountById(id).then( res => {
            if (res && res.code === "0000") {
              Message.success(`删除成功`);
              this.cleanUser();
              this.fetchUserList();
            }
          })
        } catch (e) {
          Message.error('删除失败');
        }
      }).catch(() => {

      });

    },

    handleEdit(item) {
      this.user = {
        ...item
      }
      this.visible = true

    },

    cleanUser() {
      this.user = {}
      this.currentPage = 1
    },

    handleSearch() {
      this.cleanUser();
      this.fetchUserList()
    },


    handleCommand (command, data){
      switch ( command ){
        case 'edit' : {
          this.handleEdit(data)
          break;
        }
        case 'bindRole' : {
          this.roleDialogVisible =  true
          this.selectUserId = data.id
          this.getRoleByUser()
          break;
        }
        /*case 'bindOffice' : {
          this.openBindOfficeDialog(data)
          break;
        }*/
        case 'userBind' : {
          this.$refs.userBindRef.open(data)
          break;
        }
        case 'delete' : {
          this.deleteUser(data.id)
          break;
        }
        default:
          console.warn('未知的命令:', command);
      }

    },

    async getRoleByUser(){
      const res = await getRoleIdByUserId(this.selectUserId)
      if ( res && res.code === "0000"){
        this.currentRoleId = res.result.roleId
      }
    },

    async bindRole(){
      const res = await bindRoleForUser({
        accountId : this.selectUserId,
        roleId : this.currentRoleId
      })
      if ( res && res.code === "0000"){
        Message.success('绑定成功')
        this.roleDialogVisible = false
      }
    },

    // 打开企业关联
    openBindOfficeDialog(data){
      this.bindOffice.accountId = data.id
      this.getBindOffice()
      this.officeDialogVisible =  true
    },
    async getBindOffice(){
      const resp = await getUserOfficeRef(this.bindOffice.accountId)
      if (resp && resp.code === "0000" && resp.result){
        this.bindOffice.officeId = resp.result
      }
    },

    async handleBindOffice() {
      const param = {
        ...this.bindOffice
      }
      console.log('param' ,param)
      const resp  = await bindUserOffice(param);
      if (resp && resp.code === "0000"){
        Message.success('绑定成功')
      }else {
        Message.error('绑定失败，请稍后重试')
      }
      this.cleanUser()
      this.fetchUserList();
    },

    checkRoleIdExistSem(roleId){
      return this.user.id && this.roles.find(role => role.id === roleId && role.clientType === 'SEM')
    },
    semHandleRoleChange(value){
      if (value){
        const role =  this.roles.find(role => role.id === value)
        console.log('role',role)
        this.user.chemHandlerType = role.code
      }
    },

  },
}
</script>

<template>
  <div>
    <el-card class="main-card">
      <div class="card-header">
        <div style="display: flex; align-items: center; gap: 16px;">
          <!-- 搜索区域 -->
          <div class="filter-bar">
            <el-input size="small" v-model="searchKeyword" placeholder="搜索账号/用户名/手机号" clearable class="search-input" @keyup.enter="handleSearch">
              <el-button size="small" slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
          </div>
        </div>
        <el-button type="primary" size="small" @click="openEditDrawer">新增用户</el-button>
      </div>

      <el-table :data="userList" border class="device-table" stripe highlight-current-row
                :row-class-name="tableRowClassName">

        <el-table-column prop="account" label="账号名" fixed min-width="120"/>
        <el-table-column prop="username" label="用户名" min-width="120"/>
        <el-table-column prop="gender" label="性别">
          <template slot-scope="scope">
            <span>{{ scope.row.gender === 1 ? '男' : scope.row.gender === 0 ? '女' : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="邮箱" show-overflow-tooltip/>
        <el-table-column prop="mobileNo" label="手机号"/>
        <el-table-column prop="enabled" label="是否可用">
          <template slot-scope="scope">
            <span :style="scope.row.enabled ? 'color: green' : 'color: red' ">
              {{ scope.row.enabled ? '可用' : '不可用' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="locked" label="是否锁定">
          <template slot-scope="scope">
            <span :style="scope.row.locked ? 'color: red' : 'color: green' ">
              {{ scope.row.locked ? '锁定' : '未锁定' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="expired" label="是否到期">
          <template slot-scope="scope">
            <span :style="scope.row.expired ? 'color: red' : 'color: green' ">
              {{ scope.row.expired ? '到期' : '未到期' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" min-width="120" show-overflow-tooltip/>
        <el-table-column prop="updatedTime" label="更新时间" min-width="120" show-overflow-tooltip />

        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="enableUser(scope.row.id)"
                       :style="scope.row.enabled ? 'color: red' : 'color: green' ">
              {{ scope.row.enabled ? '禁用' : '启用' }}
            </el-button>

            <el-dropdown @command="(command) => handleCommand(command, scope.row)">
              <el-button size="mini" type="text" style="margin-left: 10px; color: #4b5563;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item command="edit">编辑用户</el-dropdown-item>
                <!-- <el-dropdown-item v-if="officeId === 0" command="bindRole">授权角色</el-dropdown-item> -->
                <!-- <el-dropdown-item command="bindOffice">企业关联</el-dropdown-item> -->
                 <el-dropdown-item v-if="officeId !== 0"  command="userBind">绑定资源</el-dropdown-item>
                <el-dropdown-item command="delete" class="delete-btn">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"
                       class="pagination"></el-pagination>
      </div>
    </el-card>

    <UserBind ref="userBindRef" />
    <el-drawer
        :title="user.id ? '编辑用户': '新增用户'"
        :visible.sync="visible"
        direction="rtl"
        ref="editDrawer"
    >
      <div class="edit-container">
        <el-form ref="userForm" :model="user" label-width="100px" :rules="rules">
          <el-form-item label="所属客户端" prop="clientType" required v-if="!user.id">
            <el-select size="small" v-model="user.clientType" placeholder="请选择客户端类型" class="form-select" @change="changeClientType">
              <el-option label="平台后台" value="PLATFORM"/>
              <el-option label="安全环境管理后台" value="SEM"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="user.clientType === 'SEM' ? '手机号' : '登录账号名'" prop="account" required>
            <el-input v-model="user.account" clearable :disabled="!!user.id"/>
          </el-form-item>
          <el-form-item label="用户名" prop="username" required>
            <el-input v-model="user.username" type="text" clearable/>
          </el-form-item>
          <el-form-item label="密码" v-if="!user.id" prop="password" required>
            <el-input v-model="user.password" clearable/>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="user.gender">
              <el-radio label="1">男</el-radio>
              <el-radio label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="user.email" clearable/>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="user.mobileNo" clearable/>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="user.remark" type="textarea" clearable/>
          </el-form-item>

          <el-form-item v-if="officeId === 0"  label="所属企业" prop="officeId" required>
            <el-select v-model="user.officeId" placeholder="请选择企业" clearable style="width: 100%">
              <el-option :key="0" label="平台" :value="0" />
              <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>

          <el-form-item label="经办人类型" prop="roleId" required v-if="user.clientType === 'SEM'">
            <el-select v-model="user.roleId"    placeholder="请选择角色"  @change="semHandleRoleChange">
              <el-option v-for="item in roles.filter(role => role.clientType === 'SEM')" :key="item.id"
                         :label="item.name"
                         :value="item.id"/>
            </el-select>
          </el-form-item>

          <el-form-item label="角色" prop="roleId" required v-else>
            <el-select v-model="user.roleId"
                       :disabled="user.roleId === 2 || checkRoleIdExistSem(user.roleId)"
                       placeholder="请选择角色"
                       clearable style="width: 100%">
              <el-option v-for="item in roles" :key="item.id"
                         :label="`${item.name}${item.clientType === 'SEM' ? '(sem)' : ''}`"
                         :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="edit-footer">
          <el-button @click="$refs.editDrawer.closeDrawer()">取 消</el-button>
          <el-button type="primary" @click="submitUser" :loading="submitLoading">
            {{ submitLoading ? '提交中 ...' : '提 交' }}
          </el-button>
        </div>
      </div>
    </el-drawer>

    <el-dialog title="角色列表" :visible.sync="roleDialogVisible">
      <div style="display: flex; flex-direction: column; gap: 6px;flex: 1">
        <el-form ref="roleFormRef" style="flex: 1" >
          <el-form-item label="角色" prop="roleId">
            <el-select v-model="currentRoleId" :disabled="currentRoleId === 2" placeholder="请选择角色" clearable style="width: 100%">
              <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="display: flex; width: 100%; justify-content: right;">
          <el-button type="primary" @click="bindRole" :disabled="currentRoleId === 2">绑定角色</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="企业列表" :visible.sync="officeDialogVisible">
      <el-form :model="bindOffice" label-width="100px">
        <el-form-item label="所属企业" prop="officeId">
          <el-select v-model="bindOffice.officeId" placeholder="请选择企业" clearable style="width: 100%">
            <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="end">
        <el-button type="primary" style="width: 180px" @click="handleBindOffice">关联企业</el-button>
      </el-row>
    </el-dialog>
  </div>

</template>

<style scoped>

/* 主卡片样式 */
.main-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

.main-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}


.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.edit-container {
  display: flex;
  flex-direction: column;
  padding: 12px;
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  .edit-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
    padding: 12px;
    position: absolute;
    bottom: 0;
    right: 0;
    box-sizing: border-box;
  }
}

.table-row-even {
  background-color: #fff;
}

.table-row-odd {
  background-color: #fafafa;
}

/* 搜索区域 */
.filter-bar {
  display: flex;
  align-items: center;
}

.search-input {
  width: 280px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

}

/* 分页样式 */
.pagination-container {
  margin: 20px;
  padding-top: 15px;
  border-top: 1px solid #f0f2f5;
  text-align: right;
}


</style>
